import { NzTreeNodeOptions } from "ng-zorro-antd/tree";
import { ProjectStructure, Resource, ResourcesOfEntity } from "../models/projects.model";

export class ProjectStructureClass {

  data: ProjectStructure[] = [];

  constructor(structure: ProjectStructure[]) {
    this.data = this.buildTree(structure);
  }

  private buildTree(flatArray: ProjectStructure[]): ProjectStructure[] {
    const map = new Map<number, ProjectStructure>();
    const roots: ProjectStructure[] = [];

    flatArray.forEach(item => map.set(item.id, { ...item, SubComponents: [] }));

    map.forEach(item => {
      if (!item.parentId) {
        roots.push(item);
      } else {
        map.get(Number(item.parentId))?.SubComponents?.push(item);
      }
    });

    return roots;
  }

  buildResourcesTree(rawData: ResourcesOfEntity): ProjectStructure[] {
    const map = new Map<string, ProjectStructure>();
    const roots: ProjectStructure[] = [];

    if(rawData.key) {
      map.set(rawData.key, {
        parentId: "",
        isBatchProduction: false,
        SubComponents: [],
        ComponentResource: [],
         ...rawData
      });
    }

    const sortedNodes = rawData.Nodes?.sort((a, b) => {
      const aIsRoot = !a.parentKey || a.parentKey === '';
      const bIsRoot = !b.parentKey || b.parentKey === '';
      
      if (aIsRoot && !bIsRoot) return -1;
      if (!aIsRoot && bIsRoot) return 1;
      
      return a.order - b.order;
    });

    sortedNodes?.map(item => map.set(item.key, {
      parentId: item.parentKey,
      isBatchProduction: false,
      SubComponents: [],
      ComponentResource: [],
      ...item
    }));
    
    let index = 0;
    map.forEach((item) => {
      if (!item.parentId || index == 0) {
        index++;
        roots.push(item);
      } else {
        map.get(item.parentId)?.SubComponents?.push(item);
      }
    });

    return roots;


  }

  transformToNzTreeNode(touched = new Map<string, ResourcesOfEntity>(), elements: ProjectStructure[] = this.data): NzTreeNodeOptions[] {
    const transform = (item: ProjectStructure): NzTreeNodeOptions => {
      
      let nodeData: ResourcesOfEntity | undefined;
      if (touched.has(`${item.id}`) && item['context'] == "WBSResource") {
        nodeData = touched.get(`${item.id}`);
        item['WBSResourceNode']['currentInputQuantity'] = nodeData?.WBSResourceNode?.currentInputQuantity;
      }

      return {
        title: item.name,
        key: `${item.id}`,
        icon: '',
        children: item.SubComponents?.map(transform) || [],
        isLeaf: !item.SubComponents?.length,
        checked: false,
        selected: false,
        expanded: true,
        selectable: false,
        disabled: false,
        disabledCheckBox: false,
        ...item
      };
    };

    return elements.map(transform);
  }

  findPathByCode(code: string, tree: ProjectStructure[], touched = new Map<string, ResourcesOfEntity>): NzTreeNodeOptions[] {
    if (!code || code.trim() === '') {
      return this.transformToNzTreeNode(touched, tree);
    }

    const matchingRoots: ProjectStructure[] = [];
    const lowerCode = code.toLowerCase();

    const filterTree = (item: ProjectStructure): ProjectStructure | null => {
      const matches = item.code?.toLowerCase().includes(lowerCode) || 
                     item.name?.toLowerCase().includes(lowerCode);
      
      if (matches) {
        return item;
      }

      const filteredChildren = item.SubComponents
        ?.map(child => filterTree(child))
        .filter(child => child !== null) as ProjectStructure[] || [];

      if (filteredChildren.length > 0) {
        return {
          ...item,
          SubComponents: filteredChildren
        };
      }

      return null;
    };

    tree.forEach(root => {
      const filtered = filterTree(root);
      if (filtered) {
        matchingRoots.push(filtered);
      }
    });

    return this.transformToNzTreeNode( touched, matchingRoots);
  }

  findPathByName(name: string, touched =new Map<string, ResourcesOfEntity>(), tree: ProjectStructure[] = this.data, ): NzTreeNodeOptions[] {
    return this.findPathByCode(name, tree, touched);
  }

  getEntryByCode(code: string, touched =new Map<string, ResourcesOfEntity>(), tree: ProjectStructure[] = this.data, ): NzTreeNodeOptions | null {
    const path = this.findPathByCode(code, tree, touched);
    return path.length > 0 ? path[path.length - 1] : null;
  }




}